<template>
  <drop class="drop" @drop="handleDrop">
    <div class="bus-place" v-bind:class="{ taken: !free }">
      <div class="close-btn" @click="clear" v-if="!free && !locked">X</div>
      <div class="locker" v-if="locked"><i class="fa fa-lock" /></div>
      <div class="place-text">
        <div class="place-label">{{label}}</div>
        <div class="traveler-name-container">
          <div class="traveler-name" v-if="!free" @click="userClicked">{{person.name}}</div>
        </div>
      </div>
    </div>
  </drop>
</template>

<script>
import { Drop } from "vue-drag-drop";
export default {
  name: "busplace",
  components: {
    Drop
  },
  props: {
    label: {
      type: Number
    },
    traveler: {
      type: Object
    }
  },
  data() {
    let isFree = true
    let isLocked = false
    let person = null

    if(this.traveler) {
      isFree = false
      isLocked = this.traveler.locked === true      
      person = this.traveler
    }

    return {
      locked: isLocked,
      free: isFree,
      person: person
    };
  },
  mounted: function() {
  },
  methods: {
    handleDrop(data) {
      if(this.free) {
        let eventData = { place: this.label, person: data.person }
        this.$emit("placed", eventData)
        this.person = data.person
        this.free = false
      }
    },

    handleDragover(data, e) {
      // e.dataTransfer.dropEffect = 'move';
      this.effectAllowed = e.dataTransfer.effectAllowed;
      this.dropEffect = e.dataTransfer.dropEffect;
    },

    clear() {
      let eventData = { place: this.label, person: this.person }
      this.$emit("remove", eventData)
      this.person = null
      this.free = true
    },

    userClicked() {
      let eventData = { place: this.label, person: this.person }
      this.$emit("nameClicked", eventData);
    }

  },
  computed: {},
  watch: {
    traveler: function (val, old) {
      if(val) {
        this.free = false
        this.locked = val.locked === true      
        this.person = val
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$busPlaceBorderRadius: 30px;
$busPlaceBorderColor: #4ae387;

.bus-place {
  height: 100%;
  position: relative;
  border-radius: $busPlaceBorderRadius;
  
}
.locker {
  position: absolute;
  color: #888888;
  top: 5px;
  left: 10px;
  user-select: none;  
}
.close-btn {
  position: absolute;
  color: red;
  top: 5px;
  right: 10px;
  user-select: none;  
  cursor: pointer;
}
.place-text {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  // align-items: center;
}
.place-label {
  padding-top: 5px;
  width: 100%;
  text-align: center;
  font-size: 14pt;
  font-weight: 600;
}
.taken {
  background-color: #4ae38748;
}
.traveler-name-container {
  height: 100%;
  display: flex;
  align-items: center;
}
.traveler-name {
  cursor: pointer;
  font-weight: 50;
  user-select: none;  
}
</style>
